'use strict';

/* global $ */

import { Slider } from './slider';

function Partners (options) {
    var opt = _.merge({ }, { wrap: '.js-partners',
                              item: '.js-partners-item',
                              slider_options: { }
                            }, options);

    var $wrap = $(opt.wrap);
    if($wrap.length > 0) {
        var slider = new Slider($wrap, $wrap.parent(), opt.slider_options);
        slider.init();
    }
}

export {
    Partners
};

